import EnvironmentConfig from '../interfaces/EnvironmentConfig';
import developmentConfig from './development';
import e2eQaConfigs from './e2eqa';
import productionConfigs from './production';
import qaConfigs from './qa';
import preprodConfigs from "./preprod";
import demoConfigs from "./demo";

type ConfigMap = { [env: string]: EnvironmentConfig };

const configsMap: ConfigMap = {
  qa: qaConfigs,
  dev: developmentConfig,
  e2eqa: e2eQaConfigs,
  preprod: preprodConfigs,
  demo: demoConfigs,
  production: productionConfigs,
};

const localOverrides = import.meta.glob<{ default: Record<string, unknown> }>(
  './local-*.json',
  { eager: true }
);

const getEnvConfigs = () => {
  const currentEnv = import.meta.env.VITE_DEPLOY_ENV || 'dev';

  if (!currentEnv || !configsMap[currentEnv]) {
    throw new Error('No Env Found');
  }

  const localConfig =
    localOverrides[`./local-${currentEnv}.json`]?.default ?? {};

  return { ...configsMap[currentEnv], ...localConfig };
};

export default getEnvConfigs();
